import { EuiButton, EuiButtonIcon, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiLoadingSpinner, EuiPopover } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import { FacturasAdapter } from '../../../../../infraestructure/persistence/rest/FacturasAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useLanguage } from '../../../../../shared/hooks/Language';

export const UsuariosFacturablesDisponiblesInfo = (props:any)=>{

    const {filter,lenDataHistorico}=props;
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const api:any = new FacturasAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
    const {translate} = useLanguage();
	const [data,setData] = useState<any>([])
	let [isLoading, setIsLoading] = useState<boolean>(false);
	let result: any;

    useEffect(()=>{
        getUsuarios(filter)
    },[filter,lenDataHistorico])
    

    const onPopoverClick = () => setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);


    const getUsuarios = async (dataRequest:any) => {
		setIsLoading(true)
		try {
			result = await api.getUsuariosExpatriadosInfo(dataRequest);

			if(result.data && result.data!=="")
			{
				setData([...result.data])
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

    const getContent = useMemo(()=>{
        return data.length>0 ? data.map((user:string)=> <EuiFlexItem>
            <EuiFlexGroup>
                <EuiFlexItem grow={false}><EuiIcon size='m' type={'user'} /></EuiFlexItem>
                <EuiFlexItem style={{fontSize:'smaller'}}>{user}</EuiFlexItem>
            </EuiFlexGroup>
            </EuiFlexItem>) :
            <EuiFlexItem>
                <EuiFlexGroup>
                    <EuiFlexItem grow={false}><EuiIcon size='m' type={'iInCircle'} /></EuiFlexItem>
                    <EuiFlexItem style={{fontSize:'smaller'}}>{`${translate('sin-usuarios-facturables')}.`}</EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
    },[data])


    const button = (
        <EuiFlexGroup justifyContent='center'>
            <EuiFlexItem>
                <EuiButton className='btnInfoUsers' iconType={'users'} size='m' onClick={onPopoverClick}>{isLoading?<EuiLoadingSpinner size="m" />:data.length}</EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    );

    return(
        <EuiPopover
          ownFocus={false}
          button={button}
          isOpen={isPopoverOpen}
          closePopover={closePopover}
          initialFocus="[id=popover-facturar-expatriados]">
            <EuiFlexGroup direction='column' style={{maxHeight:'300px', overflowY:'auto'}}>
                {getContent}
            </EuiFlexGroup>
          </EuiPopover>
    )
}